import { createFileRoute } from '@tanstack/react-router'
import LazyRoute from '@/components/LazyRoute'

export const Route = createFileRoute('/_protected/organization/settings/members')({
  component: () => (
    <LazyRoute
      loader={() => import('@/components/organization-settings/members')}
      fallback={<div>Loading...</div>}
    />
  ),
})